import { render, staticRenderFns } from "./ContactSupervisor.vue?vue&type=template&id=2fc3131f&"
import script from "./ContactSupervisor.vue?vue&type=script&lang=js&"
export * from "./ContactSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports